import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip-info-color',
  templateUrl: './tooltip-info-color.component.html',
  standalone: false
})
export class TooltipInfoColorComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
